import clsx from 'clsx'

import { ProductContestBenefit } from '@/ts/Product'

import { BENEFIT_LIST_COLORS_DEFINITIONS } from './data/benefit-list'

function BenefitList({ benefits, color, className }: BenefitListProps) {
  const colorClass = BENEFIT_LIST_COLORS_DEFINITIONS[color]

  return (
    <ol className={clsx('list-disc', className)}>
      {benefits?.map((item) => (
        <li key={item.id} className="flex mb-1 space-x-3 ">
          <div className="flex items-center h-5">
            <div
              className={clsx(
                'rounded-full w-[10px] h-[10px] flex-shrink-0',
                colorClass
              )}
            />
          </div>
          <span className="text-[14px]">{item.content}</span>
        </li>
      ))}
    </ol>
  )
}

interface BenefitListProps {
  benefits: ProductContestBenefit[]
  color: keyof typeof BENEFIT_LIST_COLORS_DEFINITIONS
  className?: string
}

export default BenefitList
